var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTableDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.8,
    r: 12,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 18.8C8.29984 18.8 7.98595 18.6694 7.72484 18.4083C7.46373 18.1472 7.33317 17.8333 7.33317 17.4667V8.79999H6.6665V7.46665H9.99984V6.79999H13.9998V7.46665H17.3332V8.79999H16.6665V17.4667C16.6665 17.8333 16.5359 18.1472 16.2748 18.4083C16.0137 18.6694 15.6998 18.8 15.3332 18.8H8.6665ZM15.3332 8.79999H8.6665V17.4667H15.3332V8.79999ZM9.99984 16.1333H11.3332V10.1333H9.99984V16.1333ZM12.6665 16.1333H13.9998V10.1333H12.6665V16.1333Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableDelete);
export default __webpack_public_path__ + "static/media/ICON_TABLE_DELETE.51d3e2970d8eab22d9e92643ea7a20db.svg";
export { ForwardRef as ReactComponent };